var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LogoIcon, LogoTextIcon } from '@core';
import { useLocation } from 'react-router-dom';
import { DESIGNING_ROUTES } from '../../../constants/home-routes.constants';
import { HeaderNav } from './header-nav.component';
import { LogoutHeader } from './logout-header.component';
export var HomeHeader = function () {
    var pathname = useLocation().pathname;
    return (_jsxs("header", __assign({ className: "flex w-full flex-row items-center justify-between border-b border-solid border-[#EDEFF2] bg-white px-[25px] pb-[6px]" }, { children: [_jsxs("div", __assign({ className: "flex flex-row items-center gap-[12px]" }, { children: [_jsx(LogoIcon, { className: "h-[40px] w-[39px]" }), _jsx(LogoTextIcon, { className: "h-[64px] w-[170px]" })] })), (pathname.startsWith("/".concat(DESIGNING_ROUTES.main.route)) ||
                pathname.startsWith("/")) && _jsx(HeaderNav, {}), pathname.startsWith('/') && _jsx(LogoutHeader, {})] })));
};
